module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['app', this.name]
  }, [_c('AppHeader'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-11ba891e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 96
// module chunks = 4